module.exports = __webpack_public_path__ + "img/4999ad5.jpg";